import { ge, classHelper } from '@/scripts/utils/legacy-dom.js';

function fadeSwap () {
    const swaps = ge('.fade-swap', 1)
    if (!swaps) return
    for (let i = 0; i < swaps.length; i++) {
        const swap = swaps[i]
        const sets = swap.querySelectorAll('.set')
        if (!sets) continue

        classHelper(sets[0], 'a', 'active')

        let position = 0
        let delta = 1
        let skipCycle = 0

        const increment = (skipOnClick) => {
            if (!skipOnClick && skipCycle) {
                skipCycle = 0
                return
            }
            let next = delta * 1
            classHelper(sets[position], 'r', 'active')
            classHelper(sets[position + next], 'a', 'active')
            position += next
            if (position === sets.length - 1) delta = -1
            if (position === 0) delta = 1
            if (skipOnClick) skipCycle = 1
        }

        setInterval(increment, 5000)
        swap.addEventListener('click', function (e) {
            increment(1)
        })
    }
}

if (document.readyState !== 'complete') {
    fadeSwap()
} else {
    document.addEventListener('DOMContentLoaded', fadeSwap)
}
